import React, { useEffect } from "react";

import AppRoute from "./routes/AppRoute";
import OneSignal from 'react-onesignal';

import "./index.css";

if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register("/service-worker.js")
            .then((registration) => {
                console.log("Service Worker registered: ", registration);
            })
            .catch((error) => {
                console.log("Service Worker registration failed: ", error);
            });
    });
}

const App = () => {
    useEffect(() => {
    const initOneSignal = async () => {
      await OneSignal.init({
        appId: "5307a157-bd31-44c9-95ce-11a8aebaff2f",
        iceWorkerPath: "service-worker.js", // Beritahu OneSignal untuk memakai SW ini
        serviceWorkerParam: { scope: "/" },
        notifyButton: {
          enable: false,
        },
        allowLocalhostAsSecureOrigin: false, // Tambahkan ini jika masih pengujian di localhost
      });
    };

    initOneSignal();
  }, []);

    return (
        <>
            <AppRoute />
        </>
    );
};

export default App;
